<template>
  <div>
    <el-table class="table_box pc_table_box" :data="pageData" style="width: 100%"
              v-loading="loading"
              element-loading-background="rgba(0, 0, 0, 0.8)" :row-style="{ height: '59px' }"
    >
      <el-table-column prop="contract" :label="$t('contract2')" min-width="100px"></el-table-column>
      <el-table-column prop="direction" :label="$t('direction')" min-width="100px">
        <template slot-scope="scope">
          <span v-if="scope.row.direction===1" style="color: rgba(46, 189, 133, 1);">{{ $t("long") }}</span>
          <span v-else style="color: rgba(239, 69, 74, 1);">{{ $t("short") }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="amount" :label="$t('quantity')" min-width="100px"></el-table-column>
      <el-table-column prop="time" :label="$t('operation_time')" min-width="100px">
        <template slot-scope="scope">
          <span v-html="scope.row.time"></span>
        </template>
      </el-table-column>
      <el-table-column prop="cost" :label="$t('open_average_price')" min-width="100px">
      </el-table-column>
      <el-table-column prop="price" :label="$t('close_average_price')" min-width="100px"></el-table-column>
      <el-table-column prop="profit" :label="$t('realized_profit_loss')+'('+$t('return_rate')+')'" min-width="150px">
        <template slot-scope="scope">
          <div :class="parseFloat(scope.row.profit2)>=0?'long':'short'">{{scope.row.profit}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="fee" :label="$t('fee')" min-width="100px"></el-table-column>
      <el-table-column prop="type" :label="$t('type')" min-width="80px" align="center"></el-table-column>
      <el-table-column prop="pan" :label="$t('share2')" align="right" width="80px">
        <template slot-scope="scope">
          <span @click="share(scope.row)"><img src="../assets/imgs/share2.svg"/></span>
        </template>
      </el-table-column>
    </el-table>
    <el-table v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)" class="table_box mobile_table_box"
              :data="pageData" style="width: auto;padding: 0;margin-left: 15px;margin-right: 15px;" @row-click="toggleExpand" ref="mobileTable">
      <el-table-column type="expand" :label="'#'" width="20px">
        <template slot-scope="props">
          <div class="data_content" style="margin-top: 0">
            <div class="row">
              <div class="item1">
                <div class="title">{{$t('quantity')}}</div>
                <div class="value">{{props.row.amount}}</div>
              </div>
              <div class="item1">
                <div class="title">{{$t('trigger_price')}}</div>
                <div class="value">{{props.row.cost}}</div>
              </div>
              <div class="item">
                <div class="title right">{{$t("open_time")}}</div>
                <div class="right"> <span v-html="props.row.time"></span></div>
              </div>
            </div>
            <div class="row">
              <div class="item1">
                <div class="title">{{$t("open_average_price")}}</div>
                <div class="value">{{props.row.cost}}</div>
              </div>
              <div class="item">
                <div class="title right">{{$t('realized_profit_loss')}}({{$t("return_rate")}})</div>
                <div :class="'value right '+(parseFloat(props.row.profit2)>=0?'long':'short')">{{props.row.profit}}</div>
              </div>
            </div>
            <div class="row">
              <div class="item1">
                <div class="title">{{$t("fee")}}</div>
                <div class="value">{{props.row.fee}}</div>
              </div>

              <div class="item">
                <div class="title right">{{$t('type')}}</div>
                <div class="value right">{{props.row.type}}</div>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="contract" :label="$t('contract2')"></el-table-column>
      <el-table-column prop="direction" :label="$t('direction')" >
        <template slot-scope="scope">
          <span v-if="scope.row.direction===1" style="color: rgba(46, 189, 133, 1);">{{ $t("long") }}</span>
          <span v-else style="color: rgba(239, 69, 74, 1);">{{ $t("short") }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="cost" :label="$t('open_average_price')">
      </el-table-column>
      <el-table-column prop="share" align="right" :label="$t('share2')" >
        <template slot-scope="scope">
          <span @click="share(scope.row)"><img src="../assets/imgs/share2.svg" width="14" height="14"/></span>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination_box">
      <el-pagination @prev-click="prevClick()"
                     @next-click="nextClick()"
                     :page-size="pageSize"
                     align="right"
                     :current-page.sync="currentPage"
                     layout="prev, pager, next"
                     style="margin-bottom: 100px"
                     :total="this.tableData2.length"/>
    </div>
    <share1 ref="share1" :token="this.token" :contract="this.contractAddress"></share1>
  </div>


</template>

<script>
import {getHistoryData} from "../service/queryService";
import {createPerpOptionAndCall, getErc20Info, getSelectTokenInfo} from "../utils/contract";
import {isMobile, transBig2number, transTime2Date} from "../utils/functions";
import {Method} from "../config/const";
import {BigNumber} from "ethers";
import Share1 from "./share1.vue";
import {MESSAGE, registerMessage, removeMessage} from "../utils/message";

export default {
  name: "activate2",
  components: {Share1},
  props: {
    contractAddress: "",
    token: ""
  },
  data() {
    return {
      tableData2: [],
      currentPage: 1,
      loading: false,
      levelBTC:100,
      levelETH:100,
      pageSize:10,
      pageData:[]
    }
  },
  mounted() {
    registerMessage(this.updateMessage)
  },
  unmounted(){
    removeMessage(this.updateMessage)
  },
  watch:{
    currentPage(val){
      this.setPage(val)
    }
  },
  methods: {
    setPage(val){
      let start=(val - 1) * this.pageSize;
      this.pageData=this.tableData2.slice(start,start+this.pageSize)
    },
    prevClick(e) {
      this.currentPage--
    },
    nextClick() {
      this.currentPage++
    },
    async getData() {
      this.loading = true;
      if (!this.contractAddress) {
        return;
      }

      let selectInfo = await getSelectTokenInfo(this.token)
      let levelBTC = await createPerpOptionAndCall(selectInfo.perpetual, Method.getUserLeverage,this.token, this.contractAddress, "BTC");
      let levelETH = await createPerpOptionAndCall(selectInfo.perpetual, Method.getUserLeverage,this.token, this.contractAddress, "ETH");

      this.levelBTC=parseInt(levelBTC)
      this.levelETH=parseInt(levelETH)

      let data = await getHistoryData(this.contractAddress, 0);
      this.tableData2 = [];

      let selectToken = await getSelectTokenInfo(this.token);

      for (let i in data.orderHistories) {
        let order = data.orderHistories[i];
        this.tableData2.push({
          order: order.id,
          contract: selectToken.symbol + "-" + order.name,
          coin: selectToken.symbol,
          direction: order.direction,
          orderType: order.orderType,
          isBuy:order.direction==1,
          name:order.name,
          cost: (order.orderType==1||order.orderType==2) ? transBig2number(order.price):transBig2number(order.costPrice),
          price: (order.orderType==1||order.orderType==2)?'--':transBig2number(order.price),
          closePrice: order.closePrice > 0 ? transBig2number(order.closePrice) : "--",
          amount: transBig2number(order.amount),
          profit: this.calcuRate(order),
          profit2:this.calcuRate(order),
          time: isMobile()? transTime2Date(order.timestamp):transTime2Date(order.timestamp, true),
          type: this.getOrderType(order),
          fee:transBig2number(order.tradingFee)
        })
      }

      for(let i in this.tableData2){
        let order=this.tableData2[i];
        if(order.profit=="--"){
          continue;
        }
        this.tableData2[i].profit+="("+this.getHistoryReturnRate(order,(order.name=="BTC"?this.levelBTC:this.levelETH)).toFixed(2)+"%)"
      }

      this.currentPage=1;
      this.setPage(1);

      this.loading = false;


    },

    getOrderType(order) {
      //        //0-无效 1-市价开 2-限价开 3-平仓 4-Taker 爆仓 5-Maker 爆仓 6-结束止盈止损 7-撤单
      let states = [this.$t("invalid"), this.$t('open_position'), this.$t("open_position"), this.$t("close_position"), this.$t("taker_liquidation"), this.$t("maker_liquidation"), this.$t("end_take_profit_stop_loss"), this.$t("cancel_order")];
      return states[order.orderType];
    },
    calcuRate(order) {
      if (order.orderType == 1 || order.orderType == 2) {
        return "--";
      }

      let sub = BigNumber.from(0);
      if (order.direction == 1) {
        sub = BigNumber.from(order.price).sub(BigNumber.from(order.costPrice));
      } else {
        sub = BigNumber.from(order.costPrice).sub(BigNumber.from(order.price));
      }

      return transBig2number(sub.mul(order.amount).div(BigNumber.from("1000000000000000000")));
    },
    async init() {
      await this.getData();
    },
    share(row){
      if(this.$refs.share1){
        this.$refs.share1.show(row,this.levelBTC,this.levelETH,true);
      }
    },
    getHistoryReturnRate(info,lv){
      let profit=0;

      if(info.direction==1){
        profit= (parseFloat(info.price)-parseFloat(info.cost))*parseFloat(info.amount);
      }else{
        profit= -((parseFloat(info.price)-parseFloat(info.cost))*parseFloat(info.amount));
      }
      //回报率=已实现盈亏/（数量*开仓价格/杠杆倍数*10%）
      return profit*100/(parseFloat(info.amount)*parseFloat(info.cost)/lv);
    },
    updateMessage(msg,data){
      if(msg==MESSAGE.POSITION_UPDATE||msg==MESSAGE.LIMIT_UPDATE){
        this.getData()
      }
    },
    toggleExpand(row) {
      this.$refs.mobileTable.toggleRowExpansion(row);
    },

  },

  created() {
    // this.init()
  }
}
</script>

<style src="../assets/list.scss" lang="scss" scoped></style>
<style src="../assets/css/index.scss" lang="scss" scoped></style>
<style>
.el-table, .el-table__expanded-cell {
  background-color: rgba(24, 26, 32, 1);

}

.mobile_table_box {
  display: none;
}

@media (max-width: 750px) {
  .data_content{

    padding-left: 21px;
    padding-right: 21px;
    padding-bottom: 18px;
    border-radius: 10px;
    padding-top: 18px;
    background: rgba(18, 18, 18, 1);
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .row{
    display: flex;
    justify-content: space-between;
    .item1{
      flex: 1.2;
    }
    .item{
      flex: 1;
    }

  }
  .right{
    text-align: right;
  }

  .title {
    font-size: 13px !important;
    font-weight: 400 !important;
    letter-spacing: -0.4px;
    line-height: 18.82px;
    color: rgba(128, 128, 128, 1) !important;
  }

  .short{
    color: rgba(239, 69, 74, 1) !important;
  }
  .long{
    color: rgba(46, 189, 133, 1) !important;
  }

  .value {
    font-size: 13px;
    font-weight: 500;
    letter-spacing: -0.4px;
    line-height: 15.24px;
    color: rgba(255, 255, 255, 1);
    margin-top: 3px;
  }
  .pagination_box{
    margin-bottom: 200px !important;
  }

  ::v-deep .el-table__header{
    width: revert !important;
  }
  ::v-deep .el-table__body{
    width: revert !important;
  }

}

</style>
<style src="../assets/css/mobile.scss" lang="scss" scoped></style>
<style scoped lang="less">
    .title{
      font-size: 13px;
      font-weight: 400;
      letter-spacing: -0.4px;
      line-height: 18.82px;
      color: rgba(128, 128, 128, 1) !important;
    }
    .value{
      font-size: 12px;
      font-weight: 500;
      letter-spacing: -0.4px;
      line-height: 14.06px;
      //color: rgba(255, 255, 255, 1) !important;
    }


</style>


